import { IPopup } from "../technical/popup-new";
import { createPopupLayout } from "../layout/popup";
import { expressQuerySelector } from "../../common/html";
import { addParameter } from "../../utils/querystring";

export function createAiPhotobookAssistantChoice(productCode: string, continueUrl: string, designCode?: string): void {
	let popup: IPopup;

	const onBeforeOpen = (popupEl: HTMLElement) => {
		const continueUrlEl = expressQuerySelector<HTMLAnchorElement>(popupEl, ".technical-continueUrl", true);
		const assistantUrlEl = expressQuerySelector<HTMLAnchorElement>(popupEl, ".technical-assistantUrl", true);
		continueUrl = addParameter("showAssistant", "false", continueUrl);
		let assistantUrl = addParameter("productcode", productCode, assistantUrlEl.href);
		if (designCode) assistantUrl = addParameter("design", designCode, assistantUrl);
		continueUrlEl.setAttribute("href", continueUrl);
		assistantUrlEl.setAttribute("href", assistantUrl);
	};

	createPopupLayout({
		dialogId: "aiPhotobookAssistantChoice",
		view: "AiPhotobookAssistantPopup",
		onBeforeOpen,
	}).then((r) => {
		popup = r;
		if (popup) {
			popup.openAsync();
		}
	});
}
